import React from "react";
import { InteractiveButton } from "../../InteractiveButton.jsx";
import { useInteractiveProductsSettings } from "../../../context/interactive-product-context.jsx";
import { optionalTranslation } from "../../../../translations/translation-utils.js";

export const ShoppingCartButton = ({ href }) => {
	const { shoppingCartIcon, translations } = useInteractiveProductsSettings();

	const handleShoppingCartButtonClick = (event) => {
		event.stopPropagation();
	};

	return (
		<InteractiveButton
			href={href}
			buttonImageSrc={shoppingCartIcon}
			onClick={handleShoppingCartButtonClick}
			linkOpenInNewTab
			imgIconImageAlt={optionalTranslation(translations["button.cart.icon.alt"])}
		/>
	);
};
